import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ScreenService } from '../../shared/services/screen/screen.service';
import { Course } from './interfaces/course.interface';

@Component({
  selector: 'app-education',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './education.component.html',
  styleUrls: ['./education.component.css'],
})
export class EducationComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  courses: Course[] = [];
  isMobile = false;

  constructor(
    private translate: TranslateService,
    private screenService: ScreenService
  ) {}

  ngOnInit(): void {
    this.loadCourses();

    this.screenService.isMobile$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isMobile) => {
      this.isMobile = isMobile;
    });

    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.loadCourses();
    });
  }

  private loadCourses(): void {
    this.translate.get('education.courses.list').subscribe((res) => {
      if (Array.isArray(res)) {
        this.courses = res;
      }
    });
  }
}

